// Library methods

// Utils
import { POST, GET } from '../../../utils/fetchWrappers';

// API URLs
import {
    API_FETCH_BIN_RECENT,
    API_BIN_UPLOAD_FILE,
    API_DOWNLOAD_BY_REQUEST,
    API_SEARCH_BIN_DETAIL,
    API_BIN_UPDATE_DETAIL,
    API_RECENT_SEARCH,
    API_NETWORK_BIN_UPLOAD_FILE,
} from '../../../utils/API/apiUrls';

// API Status Codes
import { apiStatusCodes } from '../../../utils/API/apiStatusCodes';

// Redux Actions
import * as loaderActions from '../../../redux/common/loader/loader.actions';
import * as binActions from './manageBin.actions';

// Constants
import {
    FETCH_BIN_REQUEST,
    UPLOAD_BIN_FILE_REQUEST,
    SEARCH_BIN_DETAIL_REQUEST,
    UPDATE_BIN_DETAIL_REQUEST,
    DOWNLOAD_BY_ID_REQUEST,
    GET_SEARCH_RECENT_BIN_REQUEST,
    UPLOAD_NETWORK_BIN_FILE_REQUEST,
} from './manageBin.constants';
import { toast } from 'react-toastify';
import { takeLatest, put, call } from 'redux-saga/effects';

const downloadFile = url => {
    const link = document.createElement('a');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export function* fetchBinRecentDetails(actions) {
    yield put(binActions.showLoader());
    try {
        const request = {
            fileProcessEnum: 'ISSUER_BIN_FILE_UPLOAD',
        };
        const { data } = yield call(POST, API_FETCH_BIN_RECENT, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(binActions.fetchBinDataSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                binActions.fetchBinDataError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(binActions.fetchBinDataError({ error: data }));
    }
    yield put(binActions.hideLoader());
}

export function* uploadBinFileDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(
            POST,
            API_BIN_UPLOAD_FILE,
            payload,
            {
                'Content-Type': 'multipart/form-data',
            },
            true
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(binActions.uploadBinFileSuccess(data));
            toast.info('File upload successful');
        } else if (data && data.errorMessage) {
            yield put(
                binActions.uploadBinFileError({
                    error: data.errorMessage,
                })
            );
            toast.info(data.errorMessage);
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(binActions.uploadBinFileError({ error: data }));
        if (data.errorMessage) {
            toast.info(data.errorMessage);
        }
    }
    yield put(loaderActions.hideLoader());
}

export function* downloadByIdDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(POST, API_DOWNLOAD_BY_REQUEST, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            downloadFile(data.fileUrl);
        } else if (data && data.errorMessage) {
            yield put(
                binActions.downloadByIdError({
                    error: data.errorMessage,
                })
            );
            toast.info(data.errorMessage);
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(binActions.downloadByIdError({ error: data }));
        if (data.errorMessage) {
            toast.info(data.errorMessage);
        }
    }
    yield put(loaderActions.hideLoader());
}

export function* searchBinDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(POST, API_SEARCH_BIN_DETAIL, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(binActions.searchBinDetailSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                binActions.searchBinDetailError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(binActions.searchBinDetailError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* updateBinDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(POST, API_BIN_UPDATE_DETAIL, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(binActions.updateBinDetailSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                binActions.updateBinDetailError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(binActions.updateBinDetailError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* getRecentSearch() {
    yield put(binActions.showLoader());
    try {
        const { data } = yield call(GET, API_RECENT_SEARCH);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(binActions.getSearchRecentSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                binActions.getSearchRecentError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(binActions.getSearchRecentError({ error: data }));
    }
    yield put(binActions.hideLoader());
}

export function* uploadNetworkBinFileDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(
            POST,
            API_NETWORK_BIN_UPLOAD_FILE,
            payload,
            {
                'Content-Type': 'multipart/form-data',
            },
            true
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(binActions.uploadNetworkBinFileSuccess(data));
            toast.info('File upload successful');
        } else if (data && data.errorMessage) {
            yield put(
                binActions.uploadNetworkBinFileError({
                    error: data.errorMessage,
                })
            );
            toast.info(data.errorMessage);
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(binActions.uploadNetworkBinFileError({ error: data }));
        if (data.errorMessage) {
            toast.info(data.errorMessage);
        }
    }
    yield put(loaderActions.hideLoader());
}

/**
 * WATCHER SAGA
 */
export function* manageBinSaga() {
    yield takeLatest(FETCH_BIN_REQUEST, fetchBinRecentDetails);
    yield takeLatest(UPLOAD_BIN_FILE_REQUEST, uploadBinFileDetails);
    yield takeLatest(
        UPLOAD_NETWORK_BIN_FILE_REQUEST,
        uploadNetworkBinFileDetails
    );
    yield takeLatest(SEARCH_BIN_DETAIL_REQUEST, searchBinDetails);
    yield takeLatest(UPDATE_BIN_DETAIL_REQUEST, updateBinDetails);
    yield takeLatest(DOWNLOAD_BY_ID_REQUEST, downloadByIdDetails);
    yield takeLatest(GET_SEARCH_RECENT_BIN_REQUEST, getRecentSearch);
}
